<div class="d-flex justify-content-end align-items-center c-vehicle-header-driver">
    <p class="c-vehicle-header-driver__full-name">{{driver.name ? driver.name : driver|fullName}}</p>
    <p class="c-vehicle-header-driver__contact mx-s">{{driver.phoneNumber ? 'tel. ' + driver.phoneNumber : driver.email}}</p>
    <app-user-avatar size="40" [avatar]="driver.avatarUrl"
                     [initials]="driver.name ? (driver.name|initials) : (driver|fullName|initials)"
                     [round]="true"></app-user-avatar>
</div>
